/**
 * GDPR Consent Management for External Resources
 * Handles user consent for loading OpenStreetMap tiles
 */

const CONSENT_STORAGE_KEY = 'osm_consent';

export enum ConsentStatus {
  GRANTED = 'granted',
  DENIED = 'denied',
  PENDING = 'pending'
}

/**
 * Get the current consent status from localStorage
 */
export function getConsentStatus(): ConsentStatus {
  const stored = localStorage.getItem(CONSENT_STORAGE_KEY);

  if (stored === ConsentStatus.GRANTED) {
    return ConsentStatus.GRANTED;
  } else if (stored === ConsentStatus.DENIED) {
    return ConsentStatus.DENIED;
  }

  return ConsentStatus.PENDING;
}

/**
 * Store the user's consent decision
 */
export function setConsent(granted: boolean): void {
  const status = granted ? ConsentStatus.GRANTED : ConsentStatus.DENIED;
  localStorage.setItem(CONSENT_STORAGE_KEY, status);
}

/**
 * Check if user has granted consent
 */
export function hasConsent(): boolean {
  return getConsentStatus() === ConsentStatus.GRANTED;
}

/**
 * Reset consent (for testing or user preference changes)
 */
export function resetConsent(): void {
  localStorage.removeItem(CONSENT_STORAGE_KEY);
}
